import React from 'react';

import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import _ from 'es-toolkit/compat';

import { Modal, ModalTopAction } from 'src/components/common';
import { PeoStaffViewDetailsModalForm } from 'src/components/peoStaff';
import { ModalId } from 'src/constants/modals';
import { useScreenInfo } from 'src/hooks/common';
import { useModal } from 'src/hooks/shared';

import { PeoStaffViewDetailsModalArgs } from './types';

export const PeoStaffViewDetailsModal: React.FC = () => {
  const { isMobile } = useScreenInfo();
  const { closeModal, switchClosability, isOpen, args } = useModal<PeoStaffViewDetailsModalArgs>(
    ModalId.PeoStaffViewDetails,
  );

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  const mobileTopAction = React.useMemo((): ModalTopAction => {
    return {
      show: true,
      render: () => (
        <IconButton onClick={() => handleCloseModal()}>
          <CloseIcon />
        </IconButton>
      ),
    };
  }, [handleCloseModal]);

  if (isOpen && _.isNil(args?.peoStaffId)) {
    throw new Error('Some required arguments for modal are not provided');
  }

  return (
    <Modal
      title="Staff Details"
      topAction={isMobile ? mobileTopAction : undefined}
      dialogProps={{
        onClose: handleCloseModal,
        open: isOpen,
        fullScreen: isMobile,
      }}
      maxWidth={740}
    >
      <PeoStaffViewDetailsModalForm
        peoStaffId={args?.peoStaffId}
        handleCloseModal={handleCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
